<!-- Modal for deleting a plan -->
<template>
	<PrecoaModal
		v-if="modelValue && plan"
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
	>
		<template #default>
			<p class="text-md text-secondary-900 my-4 text-center font-semibold">
				{{ t('memorialGuide.removePersonTitle') }}
			</p>
			<p class="text-center text-sm text-slate-500">
				{{ t('memorialGuide.removePersonMessage') }}
			</p>
		</template>

		<template #buttons>
			<div class="flex w-full flex-col items-center justify-center">
				<button
					type="button"
					@click="confirmDelete"
					class="pb-6 font-bold text-red-500! underline"
				>
					{{ t('memorialGuide.removePerson') }}
				</button>

				<button
					type="button"
					@click="emit('update:modelValue', false)"
					class="bg-accent-400! text-accent-700! hover:bg-accent-700! mb-4 w-full rounded-lg p-3 text-center font-bold hover:text-white!"
				>
					{{ t('general.cancel') }}
				</button>
			</div>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import type Plan from '@/classes/Plan'
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import { usePresentationLocale } from '@/i18n'
import { usePlanStore } from '@/stores/plan'
import { useSessionStore } from '@/stores/session'

const { t } = usePresentationLocale()
const planStore = usePlanStore()
const sessionStore = useSessionStore()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
	(e: 'deleted'): void
}>()

const props = defineProps<{
	modelValue: boolean
	plan: Plan
}>()

// On confirmation, delete the plan and close the modal
async function confirmDelete() {
	if (!props.plan) return

	const session = sessionStore.activeSession
	if (!session) return

	session.planIds = session.planIds.filter((id) => id !== props.plan.id)

	emit('deleted')
	emit('update:modelValue', false)
}
</script>
